// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateBankCode(bankCode: string): ?UserInputValidationError {
  if (!bankCode || !bankCode.trim())
    return { id: 'empty' };

  return VALID;
}
